import { ActionTree, MutationTree, GetterTree } from 'vuex';

import { CurrencyRate } from '@/models/currency';
import { CurrencyService } from '@/services/currency-service';

const currencyService = new CurrencyService();

// TODO: LF-2021-05-29 - Need to replace with new currency store module
export const state = {
  currencies: [] as CurrencyRate[]
};

export type CurrencyState = typeof state;

export const mutations: MutationTree<CurrencyState> = {
  SET_CURRENCIES(state, payload: CurrencyRate[]) {
    state.currencies = payload;
  },

  ADD_CURRENCY(state, payload: CurrencyRate) {
    state.currencies.push(payload);
  },

  UPDATE_CURRENCY(state, payload: CurrencyRate) {
    const index = state.currencies.findIndex(
      (currency: CurrencyRate) =>
        (currency.currency as CurrencyRate)?.id ===
        (payload.currency as CurrencyRate)?.id
    );
    state.currencies.splice(index, 1, payload);
  },

  REMOVE_CURRENCY(state, payload: number) {
    const index = state.currencies.findIndex(
      (currency: CurrencyRate) => currency.id === payload
    );
    state.currencies.splice(index, 1);
  }
};

export const actions: ActionTree<CurrencyState, CurrencyState> = {
  createCurrency: (
    { commit },
    payload: { code: string; description: string }
  ) =>
    currencyService.createCurrency(payload).then((currency: CurrencyRate) => {
      commit('ADD_CURRENCY', currency);
    }),

  fetchCurrencies: ({ commit }) =>
    currencyService.fetchCurrencies().then((currencies: CurrencyRate[]) => {
      commit('SET_CURRENCIES', currencies);
    }),

  fetchCurrency: ({ dispatch }, payload: number) =>
    currencyService.fetchCurrency(payload).then((currency: CurrencyRate) => {
      dispatch('createOrUpdateCurrency', currency);
      return currency;
    }),

  updateCurrencyRate: ({ dispatch }, { id, rate }) =>
    currencyService
      .updateCurrencyExchangeRateRate(id, rate)
      .then((currency: CurrencyRate) => {
        dispatch('createOrUpdateCurrency', currency);
        return currency;
      }),

  // mutation action/ non-api action
  createOrUpdateCurrency: ({ commit }, currency: CurrencyRate) => {
    const index = state.currencies.findIndex(
      (v: CurrencyRate) =>
        (v.currency as CurrencyRate)?.id ===
        (currency.currency as CurrencyRate)?.id
    );
    if (index === -1) {
      commit('ADD_CURRENCY', currency);
    } else {
      commit('UPDATE_CURRENCY', currency);
    }
  }
};

export const getters: GetterTree<CurrencyState, CurrencyState> = {
  getCurrencyById: (state: CurrencyState) => (id: number) => {
    const data = state.currencies.find(
      currency => (currency.currency as CurrencyRate)?.id === id
    );

    if (!data) {
      return undefined;
    }

    return new CurrencyRate(data);
  },

  getCurrencies: (state: CurrencyState) => {
    return state.currencies.map(data => new CurrencyRate(data));
  }
};
